export default {
    path: '/forms/:share_code',
    name: 'shareable-form-answer',
    component: () => import('source/pages/forms/shareable/ShareableFormAnswer.vue'),
    props: true,
    meta: {
        title: 'Form - HQZen',
        loginRequired: false,
    },
};
